import { IValidationFailureTypeViewModel } from '../../../../services/ValidationFailureTypes/Api/ViewModels';

/**
 * A dictionary of validation failure types.
 *
 * The key is the error code, and the value is the validation failure type.
 */
export type VFTDictionary = Record<string, IValidationFailureTypeViewModel | undefined>;

export function createValidationFailureTypeDictionary(
    validationFailureTypes: IValidationFailureTypeViewModel[]
): VFTDictionary {
    const vftDictionary = Object.fromEntries(validationFailureTypes.map((v) => [v.ErrorCode, v]));

    return vftDictionary;
}
